var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard p-20-15"},[_vm._v(" Dashboard ")])
}
var staticRenderFns = []

export { render, staticRenderFns }